import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withStyles from '../../decorators/withStyles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router';
import styles from './WaterSlider.css';
import {SetWaterLevel} from "../../actions";
import { gaEvent } from "../../utils/utils";

const LINE_HEIGHT = 42; // px, tick spacing
const FEET_TICKS = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
const METERS_TICKS = [10, 5, 3, 2.5, 2, 1.5, 1, 0.5];
const M = "m";
const FT = "ft";

class SliderTick extends Component {

  static propTypes = {
    onClick: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired,
    waterLevel: PropTypes.object.isRequired,
  };

  handleDragOver = level => {
    this.props.dispatch(SetWaterLevel({level, unit: this.props.waterLevel.unit}));
  };

  render () {
    const { value, waterLevel } = this.props;
    let classes = "level level" + value.toString();
    if (waterLevel.level > value) {
      classes += " flooded";
    } else if (waterLevel.level === value) {
      classes += " popped";
    }

    return (
        <div onDragOver={this.handleDragOver.bind(null, value)} className="level-tick"
             onClick={this.props.onClick.bind(null, value)}
             style={{cursor: "pointer"}}
        >
          <p className={classes} style={{"lineHeight": LINE_HEIGHT + "px"}}>{value}</p>
        </div>
    )

  }
}

SliderTick = connect(() => {return {};})(SliderTick);


class WaterSlider extends Component {

  static propTypes = {
    waterLevel: PropTypes.object.isRequired,
    onLevelChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.tickMap = {
      "m": [10, 5, 3, 2.5, 2, 1.5, 1, 0.5],
      "ft": [10, 9, 8, 7, 6, 5, 4, 3, 2, 1]
    };
    // const ticks = props.waterLevel.unit == FT ? FEET_TICKS : METERS_TICKS;
    this.state = {isDragging: false};
  }

  // _feetToMeters = {
  //   "1": 0.5,
  //   "2": 0.5,
  //   "3": 1,
  //   "4": 1,
  //   "5": 1.5,
  //   "6": 2,
  //   "7": 2,
  //   "8": 2.5,
  //   "9": 2.5,
  //   "10": 3
  // };
  //
  // _metersToFeet = {
  //   "0.5": 2,
  //   "1": 3,
  //   "1.5": 5,
  //   "2": 7,
  //   "2.5": 8,
  //   "3": 10,
  //   "5": 10,
  //   "6": 10,
  //   "10": 10,
  //   "20": 10,
  //   "30": 10
  // };

  // _toggleUnit = () => {
  //   if (this.props.waterLevel.unit === FT) {
  //     this.setState({
  //       ticks: METERS_TICKS,
  //     });
  //     // this.props.onLevelChange(M, this._feetToMeters[this.props.waterLevel.level]);
  //   } else {
  //     this.setState({
  //       ticks: FEET_TICKS,
  //     });
  //     // this.props.onLevelChange(FT, this._metersToFeet[this.props.waterLevel.level]);
  //   }
  // };

  // componentDidUpdate(props) {
  //   if (props.waterLevel.unit !== this.props.waterLevel.unit) {
  //     this._toggleUnit();
  //   }
  // }

  handleDragStart = e => {
    // Disable the default drag image by replacing with a transparent single pixel image.
    const img = document.createElement('img'); img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    e.dataTransfer.setDragImage(img, 0, 0);
    this.setState({isDragging: true});
  };

  handleDragEnd = e => {
    gaEvent('configure', 'drag-end', 'water-slider-big');
    this.setState({isDragging: false});
  };

  render() {
    var self = this;
    const tickNums = this.tickMap[this.props.waterLevel.unit];
    var ticks = [];
    tickNums.forEach(function(item, i) {
      let num = tickNums.length - i;
      ticks.push(
          <SliderTick
              key={num}
              value={item}
              waterLevel={self.props.waterLevel}
              onClick={self.props.onLevelChange.bind(null, self.props.waterLevel.unit)}
          />
      );
    });

    let sliderUnitClass = function () {
      let baseClasses = "water-level-control surging-control open untouched leaflet-control";
      if (self.props.waterLevel.unit == FT) {
        return baseClasses + " unit-feet";
      } else {
        return baseClasses;
      }
    };

    const enabledClass = self.props.controlsEnabled ? "" : " disabled";

    return (
        <div className={"WaterSlider" + (this.state.isDragging ? " dragging" : "") + enabledClass}>
            <div className={sliderUnitClass()}>
              <div className="slider-toggle">
                <Link to={{pathname: "/about", hash: "#about-water-level", state: {modal: true, modalTitle: "About this site",
                                                                        returnTo: location.pathname}}}>
                  <button>
                    <span>{`Water level (${this.props.waterLevel.unit})`}</span>
                    <span className="icon question-mark" />
                  </button>
                </Link>
              </div>
              <div className="bar small">

                <div className="breakline break-five" style={{bottom: 281}}></div>
                <div className="breakline break-three" style={{bottom: 239}}></div>
                <div className="fill" style={{height: this._fillHeight()}}>
                </div>
                <div draggable="true" onDragStart={this.handleDragStart} onDragEnd={this.handleDragEnd} className="fill-circle"
                     style={{bottom: this._fillHeight() - (this._circleWidth() / 2), width: this._circleWidth(),
                         height: this._circleWidth(), "marginTop": "-32px", "marginLeft": "-32px", "fontSize": "64px",
                         cursor: "ns-resize"}}>
                  <div className="water-level" style={{top: (10 - this._sliderNotch()) * 10 + "%"}}></div>
                  <div className={"fill-text " + this._waterLevelClass()} style={{"lineHeight": "64px"}}>
                    {this.props.waterLevel.level}</div>
                </div>

                {ticks}

              </div>

              <div className="unit-selector" onClick={this._toggleUnit}>
                <div className="unit-buttons">
                  <button data-unit="feet" className={this.props.waterLevel.unit === FT ? "selected" : ""}>ft</button>
                  <button data-unit="meters" className={this.props.waterLevel.unit === M ? "selected" : ""}>m</button>
                </div>
              </div>
              <div className="slider-hider" />
            </div>
        </div>
    );
  }


  _waterLevelClass() {
    if (this.props.waterLevel.level >= 10) {
      return "doubledigit";
    } else if (parseInt(this.props.waterLevel.level, 10) !== this.props.waterLevel.level) {
      return "decimal";
    } else {
      return "";
    }
  }

  _sliderNotch() {
    const ticks = this.tickMap[this.props.waterLevel.unit];
    return ticks.length - (ticks.indexOf(this.props.waterLevel.level));
  }

  _circleWidth() {
    return 64;
  }

  _fillHeight() {
    return (LINE_HEIGHT / 2) + LINE_HEIGHT * (this._sliderNotch() - 1);
  };

}

export default compose(
  withStyles(styles),
  connect((state) => {return {controlsEnabled: state.controlsEnabled};}),
)(WaterSlider);
